import http from "../../utils/http"

/**
 * 获取列表
 */
export function jobList(params) {
    return http({
        url: "/api/recruit/page",
        data: params
    })
}

/**
 * 获取详情
 */
export function jobDetail(params) {
    return http({
        url: "/api/recruit/detail",
        data: params
    })
}
